// Italian (IT) — AI-prepared, pending native review before production.
// PT Studio family locale: covers the shared chrome used on
// /it/personal-trainer-studio (header, marquee, founder, footer, consent,
// WhatsApp) plus the full pts.* page dictionary. Keys not present here
// fall back to the English master copy automatically.
export default {
  // Header / nav
  "nav.visitWebsite": "Visita il Sito Web",

  // Marquee
  "marquee.Precision": "Precisione",
  "marquee.Performance": "Prestazioni",
  "marquee.Confidence": "Fiducia",
  "marquee.Engineering": "Ingegneria",
  "marquee.Since 1997": "Dal 1997",

  // Section labels
  "label.The Founder": "Il Fondatore",
  "label.Milestones": "Tappe Fondamentali",
  "label.Engineering Philosophy": "Filosofia di Ingegneria",

  // WhatsApp
  "wa.title": "WhatsApp",
  "wa.subtitle": "Parla con uno Specialista",

  // Footer
  "footer.contact": "Contatti",
  "footer.legal": "Note Legali",
  "footer.privacy": "Privacy Policy",
  "footer.cookies": "Cookie Policy",
  "footer.cookiePrefs": "Preferenze Cookie",
  "footer.terms": "Termini",
  "footer.visit": "Visita il sito di YANRE FITNESS EUROPE",

  // Form consent
  "consent.privacy": "Accetto il trattamento dei miei dati da parte di YANRE FITNESS EUROPE per essere contattato in merito a questo progetto.",
  "consent.marketing": "Voglio ricevere anche novità e offerte occasionali da YANRE FITNESS EUROPE. (Facoltativo)",

  // Cookie banner
  "ck.title": "Le tue scelte sulla privacy",
  "ck.desc": "Utilizziamo cookie analitici e pubblicitari opzionali solo con il tuo consenso. Puoi modificare o revocare la tua scelta in qualsiasi momento.",
  "ck.policy": "Cookie Policy",
  "ck.privacy": "Privacy Policy",
  "ck.acceptAll": "Accetta Tutto",
  "ck.reject": "Rifiuta Non Essenziali",
  "ck.manage": "Gestisci Preferenze",
  "ck.prefsTitle": "Preferenze Cookie",
  "ck.necessary": "Necessari",
  "ck.necessaryDesc": "Necessari al funzionamento del sito. Sempre attivi.",
  "ck.alwaysOn": "Sempre attivi",
  "ck.analytics": "Analitici",
  "ck.analyticsDesc": "Statistiche di utilizzo anonime che ci aiutano a migliorare questo sito.",
  "ck.advertising": "Pubblicitari",
  "ck.advertisingDesc": "Utilizzati per misurare le campagne e mostrare pubblicità pertinente.",
  "ck.save": "Salva Preferenze",

  // Cookie policy (complete Italian legal body)
  "cp.title": "Cookie Policy",
  "cp.updated": "Ultimo aggiornamento: luglio 2026",
  "cp.intro": "Questa pagina spiega come YANRE FITNESS EUROPE utilizza i cookie e tecnologie simili su questo sito web, e come puoi controllarli.",
  "cp.s1t": "Cosa memorizziamo",
  "cp.s1b": "Quando esprimi una scelta sul consenso, memorizziamo solo quella scelta (necessari, analitici, pubblicitari) nella memoria locale del tuo browser. Non contiene informazioni personali e serve esclusivamente a ricordare la tua preferenza tra una visita e l'altra.",
  "cp.s2t": "Categorie di cookie",
  "cp.s3t": "Google Tag Manager e Consent Mode",
  "cp.s3b": "Questo sito web carica un unico contenitore Google Tag Manager con Google Consent Mode v2. Tutta l'archiviazione opzionale (analitica e pubblicitaria) è impostata su \"denied\" per impostazione predefinita e viene attivata solo dopo il tuo consenso esplicito. Nessun tag analitico o pubblicitario è installato direttamente su questo sito web.",
  "cp.s4t": "Gestione del consenso",
  "cp.s4b": "Puoi modificare o revocare il tuo consenso in qualsiasi momento tramite il link \"Preferenze Cookie\" nel footer del sito web. La revoca ha effetto immediato.",
  "cp.s5t": "Contatti",
  "cp.privacyT": "Privacy",
  "cp.privacyB": "La nostra Informativa sulla Privacy completa è in fase di finalizzazione. Per qualsiasi domanda o richiesta relativa ai tuoi dati personali, contattaci all'indirizzo email indicato sopra.",
  "cp.back": "Torna alla Home",

  // Founder
  "fo.navFactory": "La Fabbrica",
  "fo.navFounder": "L'Uomo Dietro la Macchina",
  "fo.h1a": "L'Uomo",
  "fo.h1b": "Dietro",
  "fo.h1c": "la Macchina.",
  "fo.role": "Fondatore e Chief Designer",
  "fo.body": "Un atleta, un ingegnere e il fondatore di YANRE. Dal 1997 costruisce macchine per chi dà valore all'ingegneria più che al marketing.",
  "fo.quote": "“Per capire la macchina, devi capire l'uomo che c'è dietro.”",
  "fo.st1.t": "Gli Inizi",
  "fo.st1.b": "Nel 1991 George Yang non era un fondatore — era un tecnico che riparava macchine da palestra per la Nazionale atleti cinese. Riparare rivelò la verità: si allenava lui stesso sulle macchine per sentire esattamente dove cedevano.",
  "fo.st2.t": "Il Problema",
  "fo.st2.b": "Anche i marchi considerati i “migliori” del mondo avevano difetti — saldature deboli, angolazioni sbagliate e design che ignoravano il corpo umano. I limiti che vedeva hanno plasmato un modo completamente diverso di pensare l'attrezzatura.",
  "fo.st3.t": "La Fondazione",
  "fo.st3.b": "Nel 1997 smise di correggere gli errori degli altri e fissò il proprio standard — fondando Yangrui Fitness a Pechino, dal nome di suo figlio. Il nome è evoluto da Yangrui a Yanre a YR; lo standard non è mai cambiato.",
  "fo.st4.t": "L'Ingegnere",
  "fo.st4.b": "Non accetta compromessi sui materiali: acciaio qualificato Q235 con spessore minimo di 3 mm, bilancieri in 30CrMnSiA, camme e pulegge in POM a basso attrito e cavi importati dal Giappone con resistenza fino a 1400 kg. “Mi alleno io stesso su queste macchine.”",
  "fo.st5.t": "Il Designer",
  "fo.st5.b": "La sua filosofia è pulita e minimalista — il design non è come appare, ma come funziona. YANRE progetta invece di copiare; la Serie 73 è stata la prima al mondo a utilizzare traiettorie di movimento indipendenti, convergenti e divergenti.",
  "fo.st6.t": "La Visione",
  "fo.st6.b": "Una fabbrica di artigiani, non un magazzino di scatole — ordine minimo di uno, vera personalizzazione e supporto pensato per il decimo anno di una palestra, non solo per il primo giorno. Un partner, non un capo.",
  "fo.m1.t": "Prima Esperienza Tecnica",
  "fo.m1.b": "Tecnico per la Nazionale atleti cinese.",
  "fo.m2.t": "Fondazione di YANRE",
  "fo.m2.b": "Yangrui Fitness nasce a Pechino.",
  "fo.m3.t": "La Serie 73",
  "fo.m3.b": "Prime traiettorie indipendenti, convergenti e divergenti al mondo.",
  "fo.pqA": "“Realizziamo prodotti con il ",
  "fo.pqHeart": "cuore",
  "fo.pqB": ", e li realizziamo secondo uno ",
  "fo.pqStandard": "standard",
  "fo.pqEnd": ".”",
  "fo.c1.t": "Materiali",
  "fo.c1.b": "Acciaio Q235, minimo 3 mm. Camme in POM. Cavi da 1400 kg.",
  "fo.c2.t": "Biomeccanica",
  "fo.c2.b": "Traiettorie di movimento progettate intorno al corpo umano.",
  "fo.c3.t": "Durata",
  "fo.c3.b": "Costruita per durare oltre 10 anni di uso professionale.",
  "fo.c4.t": "Standard",
  "fo.c4.b": "La ISO 20957 come punto di partenza — mai come traguardo.",

  // ===== PERSONAL TRAINER STUDIO (pts.*) — it =====
  "pts.seo.title": "Studio Personal Training — Attrezzatura da Palestra Professionale | YANRE FITNESS",
  "pts.seo.description": "Apri il tuo studio personal training con l'attrezzatura professionale YANRE, direttamente dal produttore. Pacchetti iniziali intelligenti, progettazione dello spazio e supporto diretto dalla fabbrica.",
  "pts.nav.talk": "Parla con uno Specialista",
  "pts.header.cta": "Crea il Mio Studio",
  "pts.hero.label": "Studio Personal Training",
  "pts.hero.line1": "Il Tuo Studio.",
  "pts.hero.line2": "I Tuoi Clienti.",
  "pts.hero.line3": "Il Tuo Business.",
  "pts.hero.subhead": "Crea il tuo studio di personal training professionale con YANRE.",
  "pts.hero.copy": "Dal tuo primo studio privato a uno spazio premium per il personal training — attrezzatura professionale, progettazione intelligente dello spazio e supporto diretto del produttore.",
  "pts.hero.ctaPrimary": "Crea il Mio Studio",
  "pts.hero.ctaSecondary": "Parla con uno Specialista",
  "pts.hero.trust.0": "Qualità Professionale",
  "pts.hero.trust.1": "Direttamente dal Produttore",
  "pts.hero.trust.2": "Garanzia di Fabbrica",
  "pts.hero.trust.3": "Supporto Logistico",
  "pts.journey.label": "La Transizione",
  "pts.journey.h2a": "Da Personal Trainer",
  "pts.journey.h2b": "a Titolare di Studio.",
  "pts.journey.copy": "Allenare clienti nella palestra di qualcun altro costruisce il suo business. Il tuo studio costruisce il tuo — il tuo spazio, le tue relazioni con i clienti, il tuo marchio, il tuo patrimonio. L'indipendenza inizia con una sala e l'attrezzatura giusta.",
  "pts.journey.0": "Personal Trainer",
  "pts.journey.1": "Il Tuo Studio",
  "pts.journey.2": "I Tuoi Clienti",
  "pts.journey.3": "Il Tuo Marchio",
  "pts.journey.4": "Il Tuo Business",
  "pts.journey.direct": "Direttamente dal Produttore.",
  "pts.journey.directCopy": "Allestisci il tuo studio con attrezzatura professionale acquistata direttamente da YANRE — il produttore che progetta e produce ogni macchina.",
  "pts.journey.note": "Niente promesse, niente scorciatoie — solo la struttura per trasformare il tuo mestiere in un business che è tuo.",
  "pts.pkg.label": "Due Modi per Iniziare",
  "pts.pkg.h2a": "Inizia con intelligenza.",
  "pts.pkg.h2b": "Cresci alle tue condizioni.",
  "pts.pkg.intro": "Uno studio professionale inizia con un pacchetto di attrezzature selezionato con cura — e cresce nel tempo. Ogni composizione è personalizzata in base al tuo spazio, alla tua metodologia di allenamento e al tuo livello di investimento.",
  "pts.pkg.tag": "Pacchetto",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "Tutto ciò che serve per aprire uno studio di allenamento privato e professionale.",
  "pts.pkg.starter.i0": "Primo studio",
  "pts.pkg.starter.i1": "Personal trainer",
  "pts.pkg.starter.i2": "Piccoli spazi",
  "pts.pkg.starter.i3": "Allenamento 1 a 3",
  "pts.pkg.starter.i4": "Allenamento semi-privato",
  "pts.pkg.starter.concept": "Una combinazione selezionata con cura di macchine isotoniche essenziali, attrezzatura funzionale e pesi liberi.",
  "pts.pkg.starter.cta": "Crea il Mio Studio Starter",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "Una configurazione professionale completa per un business di personal training premium.",
  "pts.pkg.studiopro.i0": "Personal trainer affermati",
  "pts.pkg.studiopro.i1": "Studi premium",
  "pts.pkg.studiopro.i2": "Maggiore capacità clienti",
  "pts.pkg.studiopro.i3": "Allenamento in piccoli gruppi",
  "pts.pkg.studiopro.i4": "Allenamento di performance",
  "pts.pkg.studiopro.concept": "Una combinazione più completa di macchine isotoniche, attrezzatura funzionale, pesi liberi e cardio.",
  "pts.pkg.studiopro.cta": "Crea il Mio Studio Pro",
  "pts.pkg.idealFor": "Ideale per",
  "pts.pkg.conceptLabel": "Concept di attrezzatura",
  "pts.pkg.quote": "Richiedi il tuo preventivo di progetto",
  "pts.pkg.note": "Nessun prezzo fisso online — ogni studio viene preventivato come progetto, composto in base al tuo spazio, alla tua metodologia e al tuo livello di investimento.",
  "pts.eq.label": "Fatta per il Vero Allenamento",
  "pts.eq.h2a": "Qualità professionale.",
  "pts.eq.h2b": "Costruita per l'uso quotidiano intenso.",
  "pts.eq.copy": "Le stesse linee di attrezzatura che servono le palestre commerciali — telai progettati, movimento brevettato e durata testata in fabbrica — scalate in modo intelligente per uno studio di allenamento privato.",
  "pts.eq.strength": "Forza",
  "pts.eq.functional": "Allenamento Funzionale",
  "pts.eq.freeweights": "Pesi Liberi",
  "pts.eq.benches": "Panche e Rack",
  "pts.eq.cable": "Stazioni a Cavi",
  "pts.eq.cardio": "Cardio",
  "pts.eq.alt.strength": "Attrezzatura professionale per la forza YANRE per studi di personal training",
  "pts.eq.alt.functional": "Attrezzatura per l'allenamento funzionale YANRE per studi fitness professionali",
  "pts.eq.alt.freeweights": "Attrezzatura professionale per pesi liberi YANRE per studi di personal training",
  "pts.eq.alt.benches": "Panche e rack professionali YANRE per studi di personal training",
  "pts.eq.alt.cable": "Stazioni a cavi professionali YANRE per studi di personal training",
  "pts.eq.alt.cardio": "Attrezzatura cardio professionale YANRE per studi di personal training",
  "pts.space.label": "Progettazione dello Spazio",
  "pts.space.h2a": "Il tuo spazio.",
  "pts.space.h2b": "Il tuo progetto.",
  "pts.space.copy": "Non esistono due studi uguali. La selezione delle attrezzature e il layout sono progettati intorno alla tua realtà — non un pacchetto fisso da catalogo.",
  "pts.space.f0": "Superficie disponibile",
  "pts.space.f1": "Metodologia di allenamento",
  "pts.space.f2": "Numero di clienti simultanei",
  "pts.space.f3": "Livello di investimento",
  "pts.space.f4": "Acquisto Diretto dalla Fabbrica",
  "pts.space.f4d": "Attrezzatura professionale YANRE senza inutili livelli di rivendita.",
  "pts.space.f5": "Studio Pronto all'Uso",
  "pts.space.f5d": "Attrezzatura professionale, layout intelligente e un concept di studio completo, pronto per il tuo business.",
  "pts.space.cta": "Avvia il Mio Progetto di Studio",
  "pts.direct.label": "Direttamente dal Produttore",
  "pts.direct.h2a": "Nessun intermediario.",
  "pts.direct.h2b": "Nessun compromesso.",
  "pts.direct.copy": "YANRE è il produttore — progetta e produce la propria attrezzatura professionale dal 1997. Il tuo progetto, il tuo contratto di fornitura e la tua garanzia risiedono direttamente con la fabbrica che costruisce le tue macchine.",
  "pts.direct.p0": "Attrezzatura di livello professionale",
  "pts.direct.p1": "Rapporto diretto con il produttore",
  "pts.direct.p2": "Garanzia supportata dalla fabbrica",
  "pts.direct.p3": "Supporto logistico internazionale",
  "pts.direct.p4": "Consulenza di progetto",
  "pts.direct.p5": "Supporto post-vendita",
  "pts.process.label": "Come Funziona",
  "pts.process.h2a": "Un processo chiaro.",
  "pts.process.h2b": "Dall'idea al giorno dell'apertura.",
  "pts.process.1.t": "Consulenza",
  "pts.process.1.b": "Conosciamo te, il tuo spazio, il tuo concept e il tuo livello di investimento.",
  "pts.process.2.t": "Progetto",
  "pts.process.2.b": "Insieme definiamo la selezione delle attrezzature e il layout dello studio.",
  "pts.process.3.t": "Ordine — 30%",
  "pts.process.3.b": "Conferma il progetto e avvia la produzione con un pagamento del 30% alla fabbrica.",
  "pts.process.4.t": "Produzione",
  "pts.process.4.b": "YANRE produce e prepara la tua attrezzatura.",
  "pts.process.5.t": "70% Prima della Spedizione",
  "pts.process.5.b": "Il saldo finale viene versato prima della spedizione, secondo il contratto ufficiale.",
  "pts.process.6.t": "Spedizione",
  "pts.process.6.b": "Logistica internazionale coordinata per il tuo progetto.",
  "pts.process.7.t": "Post-Vendita",
  "pts.process.7.b": "Supporto garantito dalla fabbrica dopo l'installazione.",
  "pts.monetize.label": "Monetizza le Ore Libere dello Studio",
  "pts.monetize.h2a": "Fai lavorare il tuo studio",
  "pts.monetize.h2b": "anche quando non ci sei.",
  "pts.monetize.copy": "Il tuo studio non deve generare valore solo quando alleni i tuoi clienti. Le ore libere possono diventare un'opportunità di guadagno aggiuntiva, dando ad altri personal trainer l'accesso al tuo spazio di allenamento professionale.",
  "pts.monetize.clients": "I Tuoi Clienti",
  "pts.monetize.clientsSub": "Le tue sessioni di allenamento",
  "pts.monetize.hours": "Ore Disponibili",
  "pts.monetize.hoursSub": "Altri trainer usano il tuo studio",
  "pts.monetize.revenue": "Un'Altra Fonte di Guadagno",
  "pts.monetize.revenueSub": "Sfrutta meglio il tuo spazio durante il giorno",
  "pts.monetize.closeA": "Lo studio è tuo.",
  "pts.monetize.closeB": "Tu controlli gli orari.",
  "pts.form.label": "Avvia il Tuo Progetto di Studio",
  "pts.form.h2a": "Raccontaci",
  "pts.form.h2b": "il tuo studio.",
  "pts.form.sub": "Due minuti. Uno specialista risponde con una proposta concreta di attrezzatura per il tuo spazio e il tuo budget.",
  "pts.form.intro.sub1": "4 PASSI RAPIDI.",
  "pts.form.intro.sub2": "UNA SOLUZIONE COMPLETA PER IL TUO STUDIO.",
  "pts.form.intro.support": "Raccontaci il tuo studio in soli 4 semplici passi. Il nostro team capirà le tue esigenze e ti aiuterà a costruire la soluzione giusta — con fornitura diretta dalla fabbrica YANRE FITNESS China, consulenza professionale e assistenza post-vendita.",
  "pts.form.intro.minute": "1 MINUTO PER COMPLETARE",
  "pts.form.progress": "Passo",
  "pts.form.back": "Indietro",
  "pts.form.continue": "Continua",
  "pts.form.submit": "Ricevi il Mio Progetto di Studio",
  "pts.form.sending": "Invio…",
  "pts.form.err.step": "Completa i campi obbligatori per continuare.",
  "pts.form.err.submit": "Qualcosa è andato storto durante l'invio del tuo progetto. Riprova.",
  "pts.success.title": "Il tuo progetto di studio è stato ricevuto.",
  "pts.success.body": "Uno specialista YANRE esaminerà le tue informazioni e ti contatterà per parlare del tuo studio, delle esigenze di attrezzatura e dei prossimi passi.",
  "pts.success.reference": "Riferimento",
  "pts.success.cta": "Visita YANRE FITNESS",
  "pts.q.areYou": "Cosa ti descrive meglio?",
  "pts.q.planning": "Cosa stai pianificando?",
  "pts.q.package": "Quale pacchetto studio ti interessa?",
  "pts.q.location": "Hai già una sede?",
  "pts.q.size": "Dimensione approssimativa dello studio:",
  "pts.q.timeline": "Quando prevedi di inaugurare il tuo studio?",
  "pts.q.investment": "Qual è il tuo budget di investimento stimato? (USD)",
  "pts.q.needs": "Di cosa hai bisogno?",
  "pts.q.needsHint": "Seleziona tutto ciò che si applica.",
  "pts.q.country": "Paese",
  "pts.q.city": "Città",
  "pts.q.fullName": "Nome Completo",
  "pts.q.email": "Email",
  "pts.q.phone": "Telefono / WhatsApp",
  "pts.q.company": "Azienda / Nome dello Studio (opzionale)",
  "pts.q.selectCountry": "Seleziona il paese",
  "pts.step.1": "Studio",
  "pts.step.2": "Spazio",
  "pts.step.3": "Investimento",
  "pts.step.4": "Contatti",
  "pts.step.5": "Esigenze di Attrezzatura",
  "pts.step.6": "Contatti",
  "pts.opt.role.personal-trainer": "Personal Trainer",
  "pts.opt.role.sc-coach": "Preparatore Atletico",
  "pts.opt.role.studio-owner": "Titolare di Studio",
  "pts.opt.role.investor-entrepreneur": "Investitore / Imprenditore",
  "pts.opt.role.other": "Altro",
  "pts.opt.plan.first-studio": "Aprire il mio primo studio",
  "pts.opt.plan.upgrade-studio": "Potenziare il mio studio attuale",
  "pts.opt.plan.another-location": "Aprire un'altra sede",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "Ho bisogno di aiuto per scegliere",
  "pts.opt.loc.confirmed": "Sì",
  "pts.opt.loc.looking": "Attualmente in ricerca",
  "pts.opt.loc.not-yet": "Non ancora",
  "pts.opt.size.under-50": "Meno di 50 m²",
  "pts.opt.size.50-100": "50–100 m²",
  "pts.opt.size.100-200": "100–200 m²",
  "pts.opt.size.over-200": "Oltre 200 m²",
  "pts.opt.size.undefined": "Non ancora definita",
  "pts.opt.time.1-2": "1–2 mesi",
  "pts.opt.time.2-4": "2–4 mesi",
  "pts.opt.time.4-6": "4–6 mesi",
  "pts.opt.time.6-plus": "Più di 6 mesi",
  "pts.opt.inv.under-10k": "Meno di 10.000",
  "pts.opt.inv.10-20k": "10.000–20.000",
  "pts.opt.inv.20-40k": "20.000–40.000",
  "pts.opt.inv.40-80k": "40.000–80.000",
  "pts.opt.inv.80k-plus": "Oltre 80.000 USD",
  "pts.opt.need.complete-studio-equipment": "Attrezzatura Completa per Studio",
  "pts.opt.need.strength": "Macchine per la Forza",
  "pts.opt.need.functional": "Allenamento Funzionale",
  "pts.opt.need.cardio": "Attrezzatura Cardio",
  "pts.opt.need.full-project-help": "Ho bisogno di aiuto per il progetto completo",
  "pts.opt.role.gym-owner-operator": "Titolare / Gestore di Palestra",
  "pts.opt.inv.under-20k": "Meno di 20.000 USD",
  "pts.opt.inv.20-30k": "USD 20.000–30.000",
  "pts.opt.inv.30-50k": "USD 30.000–50.000",
  "pts.opt.inv.50-80k": "USD 50.000–80.000",
  "err.phoneInvalid": "Inserisci un numero di telefono valido per il paese selezionato.",
};
